import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/small.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="blue"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I fell for programming and picked up a thing or two along the way, I guess... 🤷‍♂️<br />
              <br />I am fluent in classics like
              <i>
                <b className="blue"> Javascript and Lua. </b>
              </i>
              <br />
              <br />
              My field of Interest's are building new
              <i>
              <b className="blue">Web Technologies and Products </b>
              </i>
              <br/>
              <br/>
              Also i create content on <b className="blue"><a href="https://www.instagram.com/wucha.dev"
                                target="_blank" rel="noreferrer">Instagram</a> </b> about programming.
             
              <br />
              <br />
              Whenever possible, I also apply my passion for developing products
              with <b className="blue">Node.js Socket.io</b> and
              <i>
                <b className="blue">
                  {" "}
                  Modern Javascript Library and Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="blue"> React.js </b>
              </i>
              <b/>
             and <b className="blue"> Tailwind </b>
             saying hello to you, too.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="blue">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/nwucha"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/nwucha/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/wucha.dev"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
